const Images = {
  logo_white: "/images/logo_white.png",
  logo_colored: "/images/logo_colored.png",
  trip_carousel_one: "/images/trip_carousel_one.png",
  trip_carousel_two: "/images/trip_carousel_two.png",
  trip_carousel_three: "/images/trip_carousel_three.png",
  trip_carousel_four: "/images/trip_carousel_four.png",
  phone: "/images/phone.png",
  logo_navbar: "/images/logo_navbar.png",
  hero_shield: "/images/hero_shield.png",
  phone_cta: "/images/phone_cta.png",
  daily_commuter: "/images/daily_commuter.png",
  okada: "/images/okada.png",
  intercity_travel: "/images/intercity_travel.png",
  taxi: "/images/taxi.png",
  insurance_company_one: "/images/insurance_company_one.png",
  insurance_company_two: "/images/insurance_company_two.png",
  about_hero: "/images/about_hero.webp",
  contact_cta: "/images/contact_us.png",
  logo_colored_white: "/images/logo_colored_white.png",

  sunu:"/images/sunu.png",

  hero_img:"/images/hero_img.png",
  how_it_works_img:"/images/how_it_works_img.png",
};
export default Images;
